import React from 'react';
import QueryHistoryComponent from '../components/QueryHistory';

const QueryHistoryPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Query History</h1>
          <p className="text-gray-600 mt-1">
            View and manage your past queries. Results are cached so you can navigate away and return later.
          </p>
        </div>
      </div>

      <QueryHistoryComponent />
    </div>
  );
};

export default QueryHistoryPage;
